<h2 mat-dialog-title class="calendar-doc-detail-title" data-testid="calendar-doc-detail-title">
    {{ datetime }}
</h2>
<div class="calendar-doc-detail-actions" data-testid="calendar-doc-detail-actions">
    @if (actionsFiltered && actionsFiltered.length) {
        <ng-container [ngTemplateOutlet]="actionsTpl"></ng-container>
    }
    <button
        mat-icon-button
        mat-dialog-close
        data-testid="calendar-doc-detail-close-button"
        [aria-label]="'MODULE_INSTANCE_CALENDAR.BUTTON_CLOSE' | translate">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content
    class="calendar-doc-detail-content"
    data-testid="calendar-doc-detail-content"
    [style.max-height.px]="detailContentMaxHeight">
    <app-data-card-view [card]="card" (click)="cardViewClick()"></app-data-card-view>
</mat-dialog-content>

<ng-template #actionsTpl>
    <button
        mat-icon-button
        data-testid="action-button"
        [matMenuTriggerFor]="actions"
        [attr.aria-label]="'MODULE_INSTANCE_CALENDAR.BUTTON_ACTIONS' | translate"
        (click)="actionsMenuClick($event)">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu class="menu-actions" #actions>
        @for (action of actionsFiltered; track action) {
            <button
                mat-menu-item
                data-testid="menu-item-action"
                class="mat-button"
                [attr.aria-label]="action.name"
                (click)="actionClick(action)">
                <mat-icon>{{ action.matIcon || "crop_din" }}</mat-icon>
                {{ action.name | translate }}
            </button>
        }
    </mat-menu>
</ng-template>
